import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { MaintenanceApi } from '../app/api/maintenance.api';


export function MaintenanceRequestModal({ onHide, show, mtype }) 
{

  const maintenance = MaintenanceApi();

  const [maintenanceType, setMaintenanceType] = useState('');
  const [subType, setSubType] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [phone, setPhone] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);


  useEffect( ()=> setMaintenanceType(mtype), [mtype] )

  const maintenanceTypes = {
    informatique: [
      'Réparation ordinateur',
      'Maintenance réseau',
      'Support technique',
      'Installation logiciel'
    ],
    biomedicale: [
      'Maintenance équipement médical',
      'Étalonnage',
      'Inspection sécurité',
      'Formation utilisateurs'
    ],
    autres: [
      'Electrcité',
      'Plomberie',
      'Maintenance générale',
    ]
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setStatus(0);
    setIsLoading(true);
    
    if (!maintenanceType || !subType || !date || !time || !phone || !confirmed) {
      alert('Veuillez remplir tous les champs');
      return;
    }
    const playload = {
      type: maintenanceType,
      subtype: subType,
      time: time,
      date: date,
      phone: phone,
    }
    try {
        const {data} = await maintenance.insert(playload);
        
        if( data.success ){
          setSubmitted(true);
        }
        else{
          setSubmitted(false);
          setStatus(-1);
        }

    } catch (err) { 

        setStatus(-1);
        const response = err?.response?.data;
      
        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].message || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }
    } finally{

        setIsLoading(false);
    }
  };

  return (
  
    <Modal show={show} size="md" onHide={onHide} centered backdrop="static">

        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="fs-5 ps-4 text-secondary">
            <i className="bi bi-tools me-2"></i>
            Demande de maintenance
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-lg-11">

                  <div className="p-2">
                  { submitted ? (
                      <div className="alert alert-success" role="alert">
                        <i className="bi bi-check-circle me-2"></i>
                        Demande soumise avec succès !
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit}>
                        {/*  */}
                        <div className="d-flex justify-content-center">
                          {
                            isLoading && (
                              <div className="d-flex justify-content-center mb-2"> 
                                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                              </div>
                            )
                          }
                          {
                            status === -1 && (
                              <div className="alert alert-danger small mb-3 w-100"> { message } </div>
                            )
                          }
                        </div>
                        {/* Sélection du type de maintenance */}
                        <div className="mb-2">
                          <label htmlFor="maintenanceType" className="ps-2 mb-1 small text-secondary">
                            Type de maintenance <span className="text-danger">*</span>
                          </label>
                          <select id="maintenanceType" className="text-secondary w-100 p-2 border" value={maintenanceType} required
                              onChange={(e) => {
                              setMaintenanceType(e.target.value);
                              setSubType('');
                            }}>
                              <option value={maintenanceType}> { maintenanceType } </option>
                          </select>
                        </div>

                        {/* Sélection du sous-type */}
                        {maintenanceType && (
                          <div className="mb-2">
                            <label htmlFor="subType" className="ps-2 mb-1 small text-secondary">
                              Sous-type de maintenance <span className="text-danger">*</span>
                            </label>
                            <select id="subType" className="text-secondary w-100 p-2 border" value={subType} onChange={(e) => setSubType(e.target.value)} required >
                              <option value="">-- Sélectionner --</option>
                              {maintenanceTypes[maintenanceType].map((type, index) => (
                                <option key={index} value={type}>
                                  {type}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {/* Date */}
                        <div className="mb-2">
                          <label htmlFor="date" className="ps-2 mb-1 small text-secondary">
                            Date d'intervention <span className="text-danger">*</span>
                          </label>
                          <input type="date" id="date" className="text-secondary w-100 p-2 border" value={date} onChange={(e) => setDate(e.target.value)} required />
                        </div>

                        {/* Heure */}
                        <div className="mb-2">
                          <label htmlFor="time" className="ps-2 mb-1 small text-secondary">
                            Heure d'intervention <span className="text-danger">*</span>
                          </label>
                          <input type="time" id="time" className="text-secondary w-100 p-2 border" value={time} onChange={(e) => setTime(e.target.value)} required />
                        </div>

                        {/* Téléphone */}
                        <div className="mb-4">
                          <label htmlFor="phone" className="ps-2 mb-1 small text-secondary">
                            Numéro de téléphone joignable <span className="text-danger">*</span>
                          </label>
                          <input type="tel" id="phone" className="text-secondary w-100 p-2 border" placeholder="+212 77 000 00 00" value={phone} onChange={(e) => setPhone(e.target.value)} />
                        </div>

                        {/* Checkbox de confirmation */}
                        <div className="mb-4 d-flex align-items-center gap-2 px-1">
                          <input type="checkbox" id="confirmation" className="border" style={{ width:"18px", height:"18px" }} checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} required />
                          <label className="form-check-label text-secondary" htmlFor="confirmation">
                            Je confirme ma demande de service de maintenance
                          </label>
                        </div>

                        {/* Bouton de soumission */}
                        <button type="submit" className="btn btn-green w-100 mb-3" disabled={!confirmed} >
                          <i className="bi bi-check-circle me-2"></i>
                          Soumettre la demande
                        </button>
                      </form>
                    )}
                  </div>
               </div>
            </div>
       </Modal.Body>
    </Modal>
    
  );
}

export function ProductModal({show, onHide, product})
{
  const [quantity, setQuantity] = useState(1);
  const [isAddToCart, setIsAddToCart] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [mainImage, setMainImage] = useState(null);


  useEffect(() => {
    if (!product) return;

    if (Array.isArray(product.images) && product.images.length > 0) {
      setMainImage(product.images[0].url);
    } else {
      setMainImage(null);
    }
  }, [product]);


  const handleThumbnailClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  const handleAddToCart = () => {

    if (!product) return;

    const cartItem = {
      product: product,
      count: quantity
    };

    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];

    const existingItem = storedCart.find(
      (item) => item.product.id === product.id
    );

    let updatedCart;

    if (existingItem) {
      updatedCart = storedCart.map((item) =>
        item.product.id === product.id
          ? { ...item, count: item.count + quantity }
          : item
      );
    } else {
      updatedCart = [...storedCart, cartItem];
    }

    localStorage.setItem("cart", JSON.stringify(updatedCart));

    setQuantity(1);

    setIsAddToCart(true);
    setTimeout(
      ()=>{
         setIsAddToCart(false);
      } , 3000
    )
  };


  return (

    
    <Modal show={show} size="xl" onHide={onHide} centered backdrop="static">
      
      <Modal.Header closeButton className="border-bottom"></Modal.Header>
      <Modal.Body>

          <div className="row g-0">
            {/* Partie Gauche : Images */}
            <div className="col-md-6 p-4">
              <div className="main-image-container mb-3 bg-light d-flex align-items-center justify-content-center">
                <img src={ mainImage && mainImage } alt="Blue High Hill" className="img-fluid" />
              </div>
              <div className="row g-2 thumb-row">
                {
                  product?.images.map((item, index) => (
                    <div className="col-3" key={index}>
                      <div 
                        className={`thumb ${ mainImage === item.url ? 'active' : '' }`}
                        onClick={() => handleThumbnailClick( item.url )}
                        style={{ cursor: 'pointer', border: mainImage === item.url ? '3px solid black' : 'none' }}
                      >
                        <img src={ item.url } alt={`img-${index + 1}`} className="img-fluid" style={{ maxHeight: '50px' }} />
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>

            {/* Partie Droite : Détails */}
            <div className="col-md-6 p-4 border-start">
              <h2 className="h3"> { product?.name } </h2>
              <div className="title-underline mb-3"></div>
          
              <div className="mb-3 text-muted" style={{ maxHeight: '250px', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                { product?.description }
              </div>

              <h3 className="product-price mb-3"> { product?.price + " " + product?.currency } </h3>

              {
                product?.video !== "" && (
                  <bouton className="btn btn-sm btn-outline-dark mb-4 px-3" onClick={ ()=> setShowVideo(true) } >
                    <i className="bi bi-play-circle-fill me-2"></i> Lire vidéo
                  </bouton>
                )
              }
              
              <div className="availability mb-4 pb-2 border-bottom">
                <small className="text-muted fw-bold"> CHOISIR LE NOMBRE DE PRODUITS </small>
              </div>

              {/* Actions : Quantité et Panier */}
              <div className="d-flex gap-3 mb-4">
                <div className="quantity-selector d-flex align-items-center border">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>-</button>
                  <input type="text" value={quantity} readOnly />
                  <button onClick={() => setQuantity(quantity + 1)}>+</button>
                </div>
                <button className="btn btn-outline-dark px-3" onClick={handleAddToCart}>
                  <i className="bi bi-plus-circle me-2"></i> Ajouter au panier
                </button>
              </div>
             
              {  
                isAddToCart && (
                  <div className="d-flex align-items-center text-green mb-3 small">
                     <i className="bi bi-check-circle me-2"></i> Produit ajouté avec succes
                  </div> )
              }

              {/* Social */}
              <div className="social-share d-flex gap-2 pt-3 border-top">
                <div className="social-circle"><i className="bi bi-facebook"></i></div>
                <div className="social-circle"><i className="bi bi-twitter"></i></div>
                <div className="social-circle"><i className="bi bi-linkedin"></i></div>
                <div className="social-circle"><i className="bi bi-google"></i></div>
                <div className="social-circle"><i className="bi bi-envelope"></i></div>
              </div>
            </div>
          </div>

          {/* Modal de Demande de Maintenance */}
          {
            product?.video && ( <VideoModal show={showVideo} onHide={() => setShowVideo(false)} video={ product?.video } /> )
          }
            
      </Modal.Body>
    </Modal>
  );
};




export function VideoModal({show, onHide, video})
{
  return (
    
    <Modal show={show} size="lg" onHide={onHide} centered backdrop="static">
      
      <Modal.Header closeButton className="border-bottom"></Modal.Header>
      <Modal.Body>
           
          <div className="ratio ratio-16x9">
            <video controls poster="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1280&q=80">
              {/* <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" /> */}
              <source src={ video } type="video/mp4" />
            </video>
          </div>
        
      </Modal.Body>
    </Modal>
  );
};




export function OrderCheckingModal({show, onHide})
{
  return (
    
    <Modal show={show} size="md" onHide={onHide} centered backdrop="static">
      
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
           
          {/* Header */}
          <div className="d-flex flex-column align-items-center">
            <img  src='../favicon.png'  alt='logo-ortega'  style={{ maxHeight: '80px' }} />
            <h1 className="login-title mb-2">Ortega</h1>
            <p className="text-secondary text-center px-4">
              Veuillez vous connecter pour accéder au service de commande.
            </p>
            <a href='/connexion' className="btn btn-outline-green px-4 rounded-0 mb-4" > 
              Se connecter  <i className="bi bi-chevron-right ms-2"></i> 
            </a> 
          </div>
        
      </Modal.Body>
    </Modal>
  );
};

